import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  return _openBlock(), _createBlock(_component_van_image, _mergeProps({
    "lazy-load": true,
    src: _ctx.innerSrc
  }, _ctx.$attrs), null, 16, ["src"]);
}